import React from "react"

export default React.createContext({
  accessToken: null,
  cycleUuid: null,
  tenantUuid: null
})
